import{a as e}from"./chunk-PT7GTM3E.js";var a=e({date:"date"});export{a};
